import { gsap, ScrollTrigger, SplitText, DrawSVGPlugin } from 'gsap/all'
gsap.registerPlugin(SplitText, ScrollTrigger, DrawSVGPlugin)
import { rotateSplitTitle } from '../animations/rotateSplitTitle'
// import Player from '@vimeo/player';
import '@vimeo/player';

export function hero(element: Element): void {
  const video = element.querySelector('.js-video') as HTMLVideoElement
  const image = element.querySelector('.js-image') as HTMLImageElement
  const imageGroup = element.querySelector('.js-image-group') as HTMLImageElement
  let player;
  if (image) gsap.set(image, { scale: 1.5 })
  if (imageGroup) gsap.set(imageGroup, { autoAlpha: 0 })

  const keylineSVG = [...Array.from(element.querySelectorAll('.js-keyline path'))] as SVGPathElement[]
  const keylineGradient = element.querySelector('.js-gradient path') as SVGPathElement
  const overlay = element.querySelector('.js-overlay') as HTMLDivElement
  const keylines = [...Array.from(element.querySelectorAll('.js-keylines path, .js-keylines polygon'))] as HTMLElement[]

  if (keylineSVG) {
    gsap.set(keylineSVG, { drawSVG: '0%' })
    gsap.set(keylineSVG, { autoAlpha: 1 })
  } 
  if (keylines) keylines.forEach(keyline => gsap.set(keyline, { drawSVG: '0%' }))
  if (keylineGradient) gsap.set(keylineGradient, { autoAlpha: 0 })
  if (overlay) gsap.set(overlay, { autoAlpha: 0 })

  // js title
  const title = [...Array.from(element.querySelectorAll('.js-title'))] as HTMLElement[]
  const subtitle = element.querySelector('.js-subtitle') as HTMLElement

  // js subtitle
  if (subtitle) {
    let newSubtitle = new SplitText(subtitle, {
      type: 'lines',
      linesClass: 'lineChild'
    })
    let innerSubtitle = new SplitText(subtitle, {
      type: 'lines',
      linesClass: 'lineParent'
    })
    gsap.set(newSubtitle.lines, { yPercent: 100 })
    gsap.to(newSubtitle.lines, { duration: 1.5, yPercent: 0, ease: 'expo.out', delay: 0.5 })
  }

  // Video Popup
  const playButton = element.querySelector('.js-play-button') as HTMLButtonElement
  const reparentDiv = document.querySelector('.js-reparent') as HTMLDivElement
  const newDiv = document.querySelector('.js-video-reparent') as HTMLDivElement

  if (video) {
    setTimeout(() => {
      video.play()
    }, 1000)
  }

  if (title) {

    gsap.to(title, {autoAlpha: 1});

    const titleObject = title.map(title => rotateSplitTitle(title))

    titleObject.forEach((title, i) => {
      gsap.to(title.chars, {
        delay: i * 0.4,
        ease: 'power1.inOut',
        autoAlpha: 1,
        rotationX: 0,
        yPercent: 0,
        stagger: {
          each: 0.03,
          from: 0
        }
      })
    })
  }

  //keyline

  if (keylineSVG) gsap.to(keylineSVG, { duration: 1.8, drawSVG: '100%', ease: 'linear', delay: 1 })
  if (keylineGradient) gsap.to(keylineGradient, { duration: 1.8, autoAlpha: 1, ease: 'expo.out', delay: 1.5 })
  if (keylines)
    keylines.map((keyline, i) =>
      gsap.to(keyline, { duration: 1.5, drawSVG: '100%', ease: 'linear', delay: 0.5 + i * 0.1 })
    )

  //image

  if (imageGroup) gsap.to(imageGroup, { duration: 1.5, autoAlpha: 1, ease: 'power2.out', delay: 0.5 })
  if (image) gsap.to(image, { duration: 1.8, scale: 1, ease: 'expo.out', delay: 0.75 })

  // overlay
  if (overlay) gsap.to(overlay, { duration: 1.8, autoAlpha: 1, ease: 'expo.out', delay: 0.75 })

  // Video play button
  if (playButton) {
    if (reparentDiv) reparentDiv.append(...Array.from(newDiv.childNodes))

    const popupVideoWrapper = document.querySelector('.js-video-popup-wrapper') as HTMLVideoElement
    const popupVideo = popupVideoWrapper.querySelector('.js-video-popup') as HTMLVideoElement
    const popupVideoEmbed = popupVideoWrapper.querySelector('.js-video-popup-embed') as HTMLVideoElement
    const iframe = popupVideo.querySelector('iframe') as HTMLVideoElement
    const popupClose = popupVideoWrapper.querySelector('.js-video-popup-close') as HTMLVideoElement
    gsap.set(popupVideo, { autoAlpha: 0, yPercent: 100 })

    playButton.addEventListener('click', openVideoPopup)
    popupVideoWrapper.addEventListener('click', handleClickOutside)
    popupClose.addEventListener('click', closePopup)

    const embed = popupVideoWrapper.querySelector('#embedVideo');
    embed.addEventListener('click', function(e) {
      player.getPaused().then(function(paused) {
          if(paused){
              player.play();
          }else{
             player.pause();
          }
      });
    })

    function openVideoPopup(e: Event) {
      e.preventDefault()
      if (window.lenis) window.lenis.stop()

      console.log(playButton)

      popupVideoWrapper.classList.add('js-open')
      gsap.to(popupVideo, { duration: 0.5, autoAlpha: 1, yPercent: 0, ease: 'power2.out' })

      if(popupVideoEmbed)
        popupVideoEmbed.play()

      window.addEventListener('keyup', handleKeyUp)

      // Config Vimeo video
      var options = {
          url: popupVideoWrapper.dataset.video,
          controls: false,
      }
      player = new Vimeo.Player('embedVideo', options);

      player.play()
    }

    function closePopup() {
      if (window.lenis) window.lenis.start()

      if(popupVideoEmbed)
        popupVideoEmbed.pause()

      // Reset the iframe on popup close
      // if(iframe) {
      //   const currentSrc = iframe.src;
      //   iframe.src = currentSrc;
      // }

      player.pause()

      gsap.to(popupVideo, {
        duration: 0.6,
        autoAlpha: 0,
        yPercent: 100,
        ease: 'expo.out',
        onComplete: () => {
          popupVideoWrapper.classList.remove('js-open')
        }
      })

      window.removeEventListener('keyup', handleKeyUp)
    }

    function handleKeyUp(event: KeyboardEvent) {
      if (event.key === 'Escape') return closePopup()
    }

    function handleClickOutside(e: Event) {
      if (e.target === e.currentTarget) {
        closePopup()
      }
    }
  }
}
